import React from 'react';
import { MailIcon, Globe2Icon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] px-5 py-14 text-center" data-id="element-70" data-mp="3gfiswe27a3c0">
      <div className="mx-auto max-w-4xl" data-id="element-71" data-mp="3gh3ng3oilm9v">
        <p className="font-display text-3xl font-bold uppercase tracking-wide text-[#d4af37]" data-id="element-72" data-mp="32ovxaurqktk5">
          Italiano Ready™
        </p>
        <p className="mt-3 font-bold text-white" data-id="element-73" data-mp="36ppjnjpj60ax">
          The #1 planning system for Italian teachers and tutors worldwide.
        </p>
        <p className="mt-2 text-sm italic text-[#B0B0C0]" data-id="element-74" data-mp="38h3r5ed5aiu">
          Because teaching shouldn’t cost you every evening of the week.
        </p>
        <div className="mx-auto mt-8 flex max-w-xl flex-wrap justify-center gap-x-6 gap-y-3 border-y border-[#d4af37]/20 py-6 text-sm font-semibold text-[#B0B0C0]" data-id="element-75" data-mp="3ldu5gwjvqrxx">
          <a className="flex items-center gap-2 hover:text-white" href="mailto:support@italianoready.com" data-id="element-76" data-mp="29ynjtg85axbw">
            <MailIcon className="h-4 w-4 text-[#d4af37]" data-id="element-77" data-mp="2ezl2rv0zbveg" />
            support@italianoready.com
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://instagram.com/italianoready" data-id="element-78" data-mp="3lbmtfq7jj4eu">
            <InstagramIcon className="h-4 w-4 text-[#d4af37]" data-id="element-79" data-mp="3v7zxni0pp0nu" />
            @italianoready
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://italianoready.com" data-id="element-80" data-mp="3q8dih31bpace">
            <Globe2Icon className="h-4 w-4 text-[#d4af37]" data-id="element-81" data-mp="817c224r7iry" />
            italianoready.com
          </a>
        </div>
        <p className="mt-8 text-[10px] font-bold uppercase tracking-widest text-[#5A5A66]" data-id="element-82" data-mp="32339clqrn25">
          © Italiano Ready™ 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}